import { Product, Region } from '@boltenergy-be/shared'
import { Address } from 'types/customer'
import { PropsWithClassName } from '@boltenergy-be/design-system'

export type StartSimulationFormProps = PropsWithClassName<{
  allowedClientTypes?: [ClientType, ...ClientType[]]
  specificProduct?: Product
  fullWidth?: boolean
  onSubmitExtraActions?: () => Promise<void>
}>

export type StartSimulationFormInputs = {
  clientType: ClientType
  energyType: EnergyType
  postalCode: Address['postalCode']
  region: Region
  townCode: Address['townCode']
  townName: Address['townName']
}

export enum EnergyType {
  ELECTRICITY = 'Electricity',
  ELECTRICITY_GAS = 'Electricity & Gas'
}

export enum ClientType {
  PROFESSIONAL = 'Professional',
  RESIDENTIAL = 'Residential'
}
